import { useLogout } from '~/providers/AutoAuthProvider';

export default function SignOut() {
  const logout = useLogout();
  logout();
  return null;
}
